import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=36189715"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports